import { render, staticRenderFns } from "./MensageriaAplicacao.vue?vue&type=template&id=303f3ef9"
import script from "./MensageriaAplicacao.vue?vue&type=script&lang=js"
export * from "./MensageriaAplicacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports